import { BrandliveEvent } from '@/types/projects.types';
import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';

const setWorkingProjectReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<BrandliveEvent | null>) => {
    state.workingProject = action.payload;
  });
};

export default setWorkingProjectReducer;
